import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ToolTip from "./ToolTip";

function isMobile() {
  const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const tabletWidth = 430;
  
  return viewportWidth <= tabletWidth;
}

function BullBear({score, status}) {  
  const scoreResult = score * 100;


  return (
    <>
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}  display="flex" maxWidth="none">
        <Grid item xs={2} sx={{textAlign: "center"}}>
          <img src={process.env.PUBLIC_URL + "/assets/Bull.svg"} alt={"Bull"} width={isMobile()?"105%":"60%"}/>
          <Typography sx={{textAlign: "center", fontWeight: "bold"}}>Bull</Typography>
        </Grid>
        <Grid sx={{textAlign: "center"}}>
          <ToolTip
            placement="top"
            arrow
            title={
              <React.Fragment>
                <Typography color="inherit" marginBottom={3} fontSize={12}>
                  Auro Daily Sentiment Rating for Digital Assets:
                </Typography>
                <Typography color="inherit" fontSize={12}>
                  100% to +66% = Outperform
                </Typography>
                <Typography color="inherit" fontSize={12}>
                  65% to 25% = Optimistic
                </Typography>
                <Typography color="inherit" fontSize={12}>
                  25% to -25% = Neutral
                </Typography>
                <Typography color="inherit" fontSize={12}>
                  -25% to -65% = Pessimistic
                </Typography>
                <Typography color="inherit" fontSize={12}>
                  -65% to -100% = Underperform
                </Typography>
              </React.Fragment>
            }
          >
            <Typography
              sx={{
                textAlign: "center",
                boxShadow: "0px 4px 4px 0px #00000040",
                color: "#D5B458",
                borderColor: "#D5B458",
                cursor: "unset",
                borderRadius: "5px",
                border: "1px solid #D5B458",
                padding: "8px",
                // height: "30px",
                alignItems: "center",
                justifyContent:"center",
                minWidth:isMobile()?"180":"210px",
                fontSize:isMobile()?"13px":"18px",
                marginLeft:isMobile()?"12px":"auto",
                marginRight:"auto",
              }}
            >
              Auro Rating: {status?.[0].toUpperCase() + status?.substring(1)} ({scoreResult > 0 ? "+" + scoreResult.toFixed(2) + "%" : scoreResult.toFixed(2) + "%"})
            </Typography>
          </ToolTip>
        </Grid>
        <Grid item xs={2} sx={{textAlign: "center"}}>
          <img src={"./assets/Bear.svg"} alt={"Bear"} width={isMobile()?"90%":"60%"} />
          <Typography sx={{textAlign: "center", fontWeight: "bold"}}>Bear</Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default BullBear;
